import { ScmType } from "@protos/common/v1/common";

export const getGitProvider = (
  repoUrlString: string | undefined
): ScmType | undefined => {
  // TODO: deprecate this and ensure that the url detection is always done
  // on the backend.
  if (repoUrlString === undefined) {
    return undefined;
  }
  const repoUrl = new URL(repoUrlString);

  if (repoUrl.hostname.includes("github")) {
    return ScmType.GITHUB;
  } else if (repoUrl.hostname.includes("gitlab")) {
    return ScmType.GITLAB;
  } else if (repoUrl.hostname.includes("bitbucket")) {
    return ScmType.BITBUCKET;
  } else if (repoUrl.hostname.includes("azure")) {
    return ScmType.AZURE_DEVOPS;
  } else {
    return undefined;
  }
};
